import React from 'react'
import styled from 'styled-components'
import { MenuNameHeader, H3 } from '@jarvis.oddle/core/components/Typo'
import Image from '@jarvis.oddle/core/components/Image'
import Flex from '@jarvis.oddle/core/components/Flex'
import breakpoint from 'src/utils/styledComponentsBreakpoint'
import { margin, marginSizes } from '@jarvis.oddle/core/theme/default'
import {
  DesktopOnly,
  MobileOnly
} from '@jarvis.oddle/core/components/Responsive/Responsive'
import { generateImageSources } from '@jarvis.oddle/core/tools/uploadcare'
import { useAppContext } from 'src/containers/AppContext'

const StyledMenuNameHeader = styled(MenuNameHeader).attrs(() => ({
  line: 2,
  marginRight: marginSizes.small,
  marginLeft: marginSizes.small
}))`
  color: ${(props) => props.color};

  && {
    height: auto;
    ${(props) => (props.font ? `font-family: ${props.font};` : '')}
  }
`

const StyledH3 = styled(H3).attrs(() => ({
  line: 2,
  marginRight: marginSizes.small,
  marginLeft: marginSizes.none
}))`
  color: ${(props) => props.color};
  max-width: 161px;

  && {
    height: auto;
    ${(props) => (props.font ? `font-family: ${props.font};` : '')}
  }
`

const StyledImage = styled(Image).attrs(() => ({
  height: '44px',
  width: 'auto'
}))`
  max-width: 135px;
  margin-right: ${margin[marginSizes.small]};
  ${breakpoint('desktop')`
    height: 60px;
    max-width: 180px;
    margin-left: ${margin[marginSizes.small]};
  `}
`

const HeaderLogo = ({
  showLogo,
  showStoreName,
  storeName,
  font,
  textColor,
  logoImage,
  isMobile
}: {
  showLogo: boolean
  showStoreName: boolean
  storeName: string
  font: string
  textColor: string | Record<string, unknown>
  logoImage: string
  isMobile?: boolean
}): JSX.Element => {
  const { getLogoImagePath } = useAppContext()
  const logoUrl = logoImage || getLogoImagePath()
  const { src, srcSet } = generateImageSources({ url: logoUrl, baseW: 60 })
  return (
    <React.Fragment>
      <DesktopOnly display='inline'>
        <Flex alignItems='center'>
          {showLogo && src && (
            <StyledImage alt={storeName} src={src} srcSet={srcSet} />
          )}
          {showStoreName && !isMobile && (
            <StyledMenuNameHeader font={font} color={textColor} normalised bold>
              {storeName}
            </StyledMenuNameHeader>
          )}
        </Flex>
      </DesktopOnly>
      <MobileOnly>
        {showLogo && src ? (
          <StyledImage alt={storeName} src={src} srcSet={srcSet} />
        ) : (
          showStoreName && (
            <StyledH3 font={font} color={textColor} normalised bold>
              {storeName}
            </StyledH3>
          )
        )}
      </MobileOnly>
    </React.Fragment>
  )
}

export default HeaderLogo
